import React from 'react';

const Digitalsec = () => {
 const services = [
  {
    id: 1,
    title: 'Email Marketing',
    desc: 'Design and send engaging email campaigns that convert. We help build subscriber lists, automate workflows, and boost engagement for higher ROI.',
    icon: 'fas fa-envelope',
    href: '/email-marketing'
  },
  {
    id: 2,
    title: 'SEO Optimization',
    desc: 'Increase your website’s visibility with proven SEO strategies. We improve rankings, optimize content, and drive steady organic traffic growth.',
    icon: 'fas fa-search',
    href: '/seo-optimization'
  },
  {
    id: 3,
    title: 'E-commerce Services',
    desc: 'Enhance your online store’s sales performance with tailored marketing solutions, from product optimization to seamless checkout experiences.',
    icon: 'fas fa-shopping-cart',
    href: '/ecommerce-marketing'
  },
  {
    id: 4,
    title: 'Content Writing',
    desc: 'Engage readers with professional, SEO-friendly content. Our writers craft blogs, articles, and web copy that attract and convert audiences.',
    icon: 'fas fa-pen',
    href: '/content-writing'
  },
  {
    id: 5,
    title: 'Research and Reporting',
    desc: 'Get clear, data-driven insights with detailed analytics and reports. We track KPIs, study competitors, and help you make smarter marketing decisions.',
    icon: 'fas fa-chart-line',
    href: '/research-report'
  }
];


  const avatarStyle = {
    width: 90,
    height: 90,
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: 34,
    background: 'var(--bs-primary-bg-subtle, rgba(0,123,255,0.08))',
    color: 'var(--bs-primary, #0066FF)',
    overflow: 'hidden'
  };

  const titleStyle = {
    color: 'var(--bs-dark, #1a2a33)',
    fontSize: '1.125rem',
    fontWeight: 700,
    marginTop: 12
  };

  const descStyle = {
    color: 'var(--bs-body-color, #4A5568)',
    lineHeight: 1.75,
    marginTop: 8,
    fontSize: '0.95rem',
    display: '-webkit-box',
    WebkitLineClamp: 2,
    WebkitBoxOrient: 'vertical',
    overflow: 'hidden',
    textOverflow: 'ellipsis'
  };

  return (
    <section className="insurance-roles-section" style={{padding: '60px 0', background: '#fff'}}>
      <div className="container-fluid" style={{padding: '0 120px'}}>
        <h2 className="insurance-roles-title" style={{textAlign: 'center', fontFamily: 'var(--bs-heading-font-family)', fontSize: '2rem', color: 'var(--bs-dark)', fontWeight: 700, marginBottom: 10}}>Digital Marketing Services</h2>
        <p className="insurance-roles-subtitle" style={{textAlign: 'center', color: 'var(--bs-body-color)', marginBottom: 40}}>Boost your online presence with our comprehensive digital marketing solutions. We help you reach your target audience and drive measurable results for your business.</p>

        <div className="insurance-roles-list row g-0" style={{gap: 20}}>
          {services.map((s, idx) => (
            <div key={s.id} className="insurance-role-item col-12" style={{marginBottom: 0}}>
              <a href={s.href} className="text-decoration-none d-flex w-100" style={{gap: 18, alignItems: 'center', padding: '18px 0'}} aria-label={`Open ${s.title}`}>
                <div className="insurance-role-avatar" style={avatarStyle} aria-hidden>
                  <i className={s.icon} aria-hidden style={{fontSize: 28}}></i>
                </div>

                <div style={{flex: '0 0 320px', minWidth: 0}}>
                  <div className="insurance-role-title" style={{...titleStyle, fontSize: '1.25rem', lineHeight: '1.1', overflowWrap: 'break-word', wordBreak: 'break-word'}}>{s.title}</div>
                </div>

                <div style={{flex: '1 1 auto', padding: '0 20px'}}>
                  <div className="insurance-role-about" style={descStyle}>{s.desc}</div>
                </div>

                <div style={{flex: '0 0 48px', display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
                  <span style={{border: '2px solid var(--bs-primary, #0066FF)', borderRadius: '50%', width: 36, height: 36, display: 'inline-flex', alignItems: 'center', justifyContent: 'center', color: 'var(--bs-primary, #0066FF)'}} aria-hidden>
                    <i className="fas fa-arrow-right" style={{fontSize: 12}}></i>
                  </span>
                </div>
              </a>

              {idx < services.length - 1 && (
                <hr style={{border: 0, borderTop: '1px solid #e8e8e8', margin: 0}} />
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Digitalsec;